// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site-header {\r\n    background-color: #dddfe1;\r\n    padding-top: 2em;\r\n}", "",{"version":3,"sources":["webpack://./screens/App/components/Header.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;AACpB","sourcesContent":[".site-header {\r\n    background-color: #dddfe1;\r\n    padding-top: 2em;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
